import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

interface Props {
  className?: string
}

const TableSection: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  return <tbody className={classNames('group ', className)}>{children}</tbody>
}

export default TableSection
